import { render, staticRenderFns } from "./AttributeMenu.vue?vue&type=template&id=76513245&"
import script from "./AttributeMenu.vue?vue&type=script&lang=ts&"
export * from "./AttributeMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports